import React, { useRef, useState, useEffect } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

const SelectDropdown = ({ 
  label, 
  value, 
  onChange, 
  options, 
  className = "w-32",
  labelClassName = "text-black text-sm border-r pr-2"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLabelClick = () => {
    // console.log('Label clicked, current state:', isOpen);
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (optionValue) => {
    // console.log('Option clicked:', optionValue);
    onChange({ target: { value: optionValue } });
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectedOption = options.find(option => option.value === value);

  return (
    <div className="w-fit relative inline-flex items-center border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-700 overflow-visible" ref={dropdownRef}>
      {label && (
        <span 
          className={`px-3 py-2 border-r border-gray-300 text-nowrap text-gray-600 cursor-pointer ${labelClassName}`} 
          onClick={handleLabelClick}
        >
          {label}
        </span>
      )}
      <div className="relative">
        <div 
          className={`w-40 appearance-none bg-white text-gray-700 text-sm font-medium rounded-md py-2 px-4 pr-10 outline-none focus:ring-2 focus:ring-blue-200 cursor-pointer flex items-center justify-between ${className}`}
          style={{ paddingRight: '2.5rem' }}
          onClick={handleLabelClick}
        >
          <span>{selectedOption ? selectedOption.label : 'Select...'}</span>
          {isOpen ? (
            <IoIosArrowUp className="absolute right-0 mr-3 pointer-events-none text-gray-500" />
          ) : (
            <IoIosArrowDown className="absolute right-0 mr-3 pointer-events-none text-gray-500" />
          )}
        </div>
        
        {isOpen && (
          <div className="absolute top-full left-0 right-0 bg-white border border-gray-300 rounded-md shadow-lg z-50 max-h-60 overflow-y-auto min-w-full">
            {options.map((option) => (
              <div
                key={option.value}
                className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                  option.value === value ? 'bg-blue-50 text-blue-600' : 'text-gray-700'
                }`}
                onClick={() => handleOptionClick(option.value)}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectDropdown; 